import { render, staticRenderFns } from "./ProcedureHistory.vue?vue&type=template&id=8baaa9e8"
import script from "./ProcedureHistory.vue?vue&type=script&lang=js"
export * from "./ProcedureHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports